module.exports = __webpack_public_path__ + "static/media/back.f71be7d6.svg";